const collectionNameMap = {
    Content: 'content',
    Products: 'product',
    Reviews: 'review',
    SecondChance: 'second_chance_product',
    Temp: undefined,
    DeliveryInstallation: undefined,
    Animations: undefined,
};
// This temporary mapping function is only necessary due to the difference in CollectionName
export function promotionalContentFactory(content) {
    var _a, _b;
    if (!content)
        return undefined;
    const mappedCollectionName = collectionNameMap[((_a = content.promoIcon) === null || _a === void 0 ? void 0 : _a.image.collectionName) || 'Content'] || 'content';
    return {
        ...(((_b = content.promoIcon) === null || _b === void 0 ? void 0 : _b.image.id) && {
            promoIcon: {
                altText: content.promoIcon.altText,
                image: {
                    id: content.promoIcon.image.id,
                    collectionName: mappedCollectionName,
                },
            },
        }),
        ...(content.promoLabel && {
            promoLabel: {
                ...content.promoLabel,
            },
        }),
    };
}
//# sourceMappingURL=promotionalContentFactory.js.map